import { Modal } from "../../../../../../../_metronic/elements/Modal";
import { useIsMobile } from "../../../../../../shared/responsive";

const PrescriptionModal = ({ open, setOpen, children }) => {
  const isMobile = useIsMobile();

  return (
    <>
      <Modal open={open} setOpen={setOpen}>
        <div className={`modal-dialog modal-dialog-scrollable prescription-modal-dialog ${isMobile ? "prescription-modal-dialog--mobile" : "modal-dialog-centered prescription-modal-dialog--desktop"}`.trim()}>
          <div className="modal-content">
            {children}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PrescriptionModal;
